import React from "react";
import { Button } from "react-bootstrap";
import muteicon from "../assets/images/muteiconactive.svg";
import speaker from "../assets/images/unmuteiconactive.svg";
const { REACT_APP_STATIC_ASSETS_BASE_URL } = process.env;

class MuteParticipant extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMuted: false
    };
  }

  toggleMute = () => {
    const { isMuted } = this.state;
    const { currentConnection } = this.props;
    currentConnection.mute(!isMuted);
    this.setState({ ...this.state, isMuted: !isMuted });
  };

  render() {
    const { isMuted } = this.state;
    const { disabled } = this.props;
    return (
      <Button
        className={`removecolorbut muteicon ${
          isMuted ? "speakerOff" : "speakerOn"
        }`}
        onClick={() => this.toggleMute()}
        disabled={disabled}
      >
        {!isMuted ? <img alt="" src={`${REACT_APP_STATIC_ASSETS_BASE_URL}${muteicon}`} /> : <img alt="" src={`${REACT_APP_STATIC_ASSETS_BASE_URL}${speaker}`} />}
        <h4>{!isMuted ? "Mute" : "Unmute"}</h4>
      </Button>
    );
  }
}
export default MuteParticipant;
